import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { appRoutes } from '../../../../path';
import { SvgIcon } from '../../../../components/Icon';
import { SecondaryButton } from '../../../../components/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
  padding: 16px;
`;

const EmptyRecentActivity = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(appRoutes.dashboard.routePrefix);
  };

  return (
    <Container>
      <SecondaryButton size="default" onClick={handleClick} isOutlined={true}>
        <SvgIcon
          name="dashboard"
          width={24}
          height={24}
          customFill="currentColor"
        />
        View a Dashboard
      </SecondaryButton>
    </Container>
  );
};

export default EmptyRecentActivity;
